<script>
  import { getExtention } from '@client/utils/files';

  export let row = {};
</script>

<div class="asset-type">
  {getExtention(row.filename)}
</div>

<style lang="scss">
  .asset-type {
    background-color: var(--color-red-300);
    border-radius: var(--border-radius-base);
    color: var(--color-white);
    display: inline-flex;
    font-size: var(--font-size-small);
    padding: var(--padding-small) var(--padding-base);
    text-transform: uppercase;
  }
</style>
